export const environment = {
  production: true,
  http_request_path:"/eacat",
  serverAddress:"https://d1uh9c64u3zgdh.cloudfront.net/eacat",
  mwfAddress:"https://d1uh9c64u3zgdh.cloudfront.net/eacat-mwf",
  fbAdress:"https://d1uh9c64u3zgdh.cloudfront.net/fbst",
  googleTaskManagerId:"GTM-KF86QPRR"
};
